import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'st-accordion',
    template: `
        <mat-accordion multi>
            <ng-content />
        </mat-accordion>
    `,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-accordion',
    },
})
export class StAccordionComponent {}
